export default "__VITE_ASSET__h7SJRSWP__"